import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

const BOARDS = 'community/boards';
const BOARD_REPLIES = 'community/boards/replies';
const KNOWHOWS = 'community/knowhows';
const KNOWHOWS_REPLIES = 'community/knowhows/replies';

/* 자유게시판 */
export const getBoard = params => {
  return ApiService.query(`${BOARDS}/${params.id}?${stringify(params)}`);
};
export const getBoardList = params => {
  return ApiService.query(`${BOARDS}?${stringify(params)}`);
};
export const createBoard = params => {
  return ApiService.multiPost(`${BOARDS}`, params);
};
export const updateBoard = params => {
  return ApiService.multiPost(`${BOARDS}/update`, params);
};
export const deleteBoard = params => {
  return ApiService.delete(`${BOARDS}/${params.id}`);
};
export const likeBoard = params => {
  return ApiService.post(`${BOARDS}/${params.id}/like`);
};
export const unlikeBoard = params => {
  return ApiService.post(`${BOARDS}/${params.id}/unlike`);
};
export const reportBoard = params => {
  return ApiService.post(`${BOARDS}/${params.id}/report?${stringify(params)}`);
};
/* 자유게시판 - 답글 */
export const getBoardReplyList = params => {
  return ApiService.query(`${BOARD_REPLIES}?${stringify(params)}`);
};
export const getBoardReplyListMine = params => {
  return ApiService.query(`community/boards/myReplies?${stringify(params)}`);
};

export const createBoardReply = params => {
  return ApiService.post(`${BOARD_REPLIES}?${stringify(params)}`);
};
export const updateBoardReply = params => {
  return ApiService.post(`${BOARD_REPLIES}/update?${stringify(params)}`);
};
export const deleteBoardReply = params => {
  return ApiService.delete(`${BOARD_REPLIES}/${params.id}`);
};
export const likeBoardReply = params => {
  return ApiService.post(`${BOARD_REPLIES}/${params.id}/like`);
};
export const unlikeBoardReply = params => {
  return ApiService.post(`${BOARD_REPLIES}/${params.id}/unlike`);
};
export const reportBoardReply = params => {
  return ApiService.post(
    `${BOARD_REPLIES}/${params.id}/report?${stringify(params)}`,
  );
};

/* 지식인 */
export const getKnowhow = params => {
  return ApiService.query(`${KNOWHOWS}/${params.id}?${stringify(params)}`);
};
export const getKnowhowList = params => {
  return ApiService.query(`${KNOWHOWS}?${stringify(params)}`);
};
export const getKnowhowAnswerList = params => {
  return ApiService.query(`${KNOWHOWS}/${params.id}/answers`);
};
export const getKnowhowAnswerDetail = params => {
  console.log('getKnowhowAnswerDetail');
  console.log(params);
  return ApiService.query(`${KNOWHOWS}/answers/${params.id}`);
};
export const createKnowhow = params => {
  return ApiService.multiPost(`${KNOWHOWS}`, params);
};
export const createKnowhowAnswer = params => {
  return ApiService.multiPost(`${KNOWHOWS}/answers`, params);
};
export const updateKnowhow = params => {
  return ApiService.multiPost(`${KNOWHOWS}/update`, params);
};
export const deleteKnowhow = params => {
  return ApiService.delete(`${KNOWHOWS}/${params.id}`);
};
export const likeKnowhow = params => {
  return ApiService.post(`${KNOWHOWS}/${params.id}/like`);
};
export const unlikeKnowhow = params => {
  return ApiService.post(`${KNOWHOWS}/${params.id}/unlike`);
};
export const reportKnowhow = params => {
  return ApiService.post(
    `${KNOWHOWS}/${params.id}/report?${stringify(params)}`,
  );
};

/* 지식인 - 답글 */
export const getKnowhowReplyList = params => {
  return ApiService.query(`${KNOWHOWS_REPLIES}?${stringify(params)}`);
};
export const getKnowhowReplyListMine = params => {
  return ApiService.query(`community/knowhows/myReplies?${stringify(params)}`);
};
export const createKnowhowReply = params => {
  return ApiService.post(`${KNOWHOWS_REPLIES}?${stringify(params)}`);
};
export const updateKnowhowReply = params => {
  return ApiService.post(`${KNOWHOWS_REPLIES}/update?${stringify(params)}`);
};
export const deleteKnowhowReply = params => {
  return ApiService.delete(`${KNOWHOWS_REPLIES}/${params.id}`);
};
export const likeKnowhowReply = params => {
  return ApiService.post(`${KNOWHOWS_REPLIES}/${params.id}/like`);
};
export const unlikeKnowhowReply = params => {
  return ApiService.post(`${KNOWHOWS_REPLIES}/${params.id}/unlike`);
};
export const reportKnowhowReply = params => {
  return ApiService.post(
    `${KNOWHOWS_REPLIES}/${params.id}/report?${stringify(params)}`,
  );
};

/* 핫이슈 */
export const getHotList = params => {
  return ApiService.query(`community/hot-issues?${stringify(params)}`);
};

// 사용자 신고하기 (자유게시판, 지식인 공통)
export const reportUser = params => {
  return ApiService.post(
    `community/user/${params.id}/report?${stringify(params)}`,
  );
};

// 인기글 리스트
export const getHotPosts = () => {
  return ApiService.query(`community/hotPosts`);
};
